// This file was auto-generated by Fern from our API Definition.
export var TopUpPackResponse;
(function (TopUpPackResponse) {
    TopUpPackResponse.Currency = {
        Usd: "usd",
    };
})(TopUpPackResponse || (TopUpPackResponse = {}));
